import apiFactory from "../../api/factory";
import epicApplicationType from "./epicApplicationType";
import factory from "../factory";
import operator from "./operator";

export default {
  epicApplicationType,
  secAnswer: factory("id", apiFactory("security/answer")),
  secAnswerSecFunction: factory("id", apiFactory("security/answerFunction")),
  secFunction: factory("id", apiFactory("security/function")),
  secFunctionInput: factory("id", apiFactory("security/functionInput")),
  operator,
  secRoleOrganization: factory("id", apiFactory("security/roleOrganization")),
  secRoleOrganizationSecAnswer: factory(
    "id",
    apiFactory("security/roleOrganizationAnswer")
  ),
  secRolePrimary: factory("id", apiFactory("security/rolePrimary")),
  secRolePrimarySecFunction: factory(
    "id",
    apiFactory("security/rolePrimaryFunction")
  ),
  secRolePrimarySecQuestion: factory(
    "id",
    apiFactory("security/rolePrimaryQuestion")
  ),
  secQuestion: factory("id", apiFactory("security/question")),
  securityClass: factory("id", apiFactory("interconnect/securityClass")),
  template: factory("id", apiFactory("interconnect/template")),
};
